<template>
  <section class="anchor">
    <div class="container">
      <Swiper slidesPerView="auto" :speed="600"
              :navigation="{prevEl:'.button_prev',nextEl:'.button_next',disabledClass:'button_disabled'}">
        <SwiperSlide v-for="(item,index) in expand.anchor">
          <a :class="{active:index===0}"
             @click="$router.push({hash:item.hash})">
            {{ item.title }}
          </a>
        </SwiperSlide>
      </Swiper>
      <a-button type="link" class="button_prev">
        <template #icon>
          <LeftOutlined />
        </template>
      </a-button>
      <a-button type="link" class="button_next">
        <template #icon>
          <RightOutlined />
        </template>
      </a-button>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { DataInterface } from '@interface/public';

export default {
  name: 'home_anchor',
  components: {
    LeftOutlined,
    RightOutlined,
    Swiper,
    SwiperSlide
  },
  data(): DataInterface {
    return {
      expand: {
        anchor: [
          // {
          //   title: '视频简介',
          //   hash: '#video'
          // },
          {
            title: '核心产品',
            hash: '#core'
          },
          {
            title: '亮点功能',
            hash: '#highlight'
          },
          {
            title: '专利技术',
            hash: '#plan'
          },
          {
            title: '商业化方案',
            hash: '#case'
          }
        ]
      }
    };
  },
  beforeCreate(): void {
    SwiperCore.use([ Navigation ]);
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/home/';
@c_1: #424656;
@h: 70px;

.anchor {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 0;
    margin: 0 auto;
    .borderBox();
    
    &::before {
      content: '';
      display: block;
      .position(absolute, auto, -40px, 0, -40px);
      z-index: 2;
      height: 1px;
      background: #cacdd4;
    }
  }
}

.swiper {
  .swiper-slide {
    position: relative;
    z-index: 0;
    width: auto;
    
    &:last-child {
      a {
        margin-right: 0 !important;
      }
    }
    
    a {
      display: inline-block;
      position: relative;
      z-index: 0;
      margin-right: 50px;
      .font(justify, @h, @c_1, @text);
      .transition(color @time);
      
      &::before {
        content: '';
        display: block;
        .position(bottom);
        width: 100%;
        height: 4px;
        border-radius: 4px 4px 0 0;
        background: @color_6;
        opacity: 0;
        .transition(opacity @time);
      }
      
      &:hover,
      &.active {
        color: @color_6;
        
        &::before {
          opacity: 1;
        }
      }
    }
  }
}

.button_prev,
.button_next {
  display: block;
  .position(absolute, 0, auto, 0, auto);
  z-index: 1;
  width: 30px;
  min-width: auto;
  height: @h;
  padding: 0;
  margin: auto 0;
  .borderBox();
  
  &.button_disabled {
    display: none;
  }
  
  > * {
    .font(center, @h, @c_1, @font_7);
  }
}

.button_prev {
  left: -20px;
}

.button_next {
  right: -20px;
}

@media screen and (max-width: -1px+@grid_md) {
  @h: 50px;
  
  .anchor {
    .container {
      &::before,
      &::after {
        display: block;
      }
    }
  }
  
  .swiper {
    margin: 0 10px;
    
    .swiper-slide {
      a {
        margin-right: 15px;
        .font(justify, @h, @c_1, @text_mo);
        
        &:hover {
          color: @c_1;
          
          &::before {
            opacity: 0;
          }
        }
      }
    }
  }
  
  .button_prev,
  .button_next {
    height: @h;
  }
}
</style>